import LoanCriteria from './LoanCriteria';

export default LoanCriteria;
